import clsx from 'clsx';
import { useMemo } from 'react';
import { AppRouteConfigs } from 'src/app/AppRoutes';
import { useAppContext } from 'src/contexts/AppContext';
import { hasAccessToRoute } from 'src/utils/userUtils';

import { MenuItem } from '../MenuItem/MenuItem';
import * as styles from './MainMenu.css';

export const MainMenu = ({
  toggleClose,
  collapsedNav,
}: {
  toggleClose: () => void;
  collapsedNav: boolean;
}) => {
  const { loginContext, appContext, mainRoute } = useAppContext();

  const user = loginContext?.user;
  const features = appContext?.features;
  const allowedRoutes = useMemo(
    () =>
      Object.values(AppRouteConfigs)
        .filter(
          (r) => r.view != null && hasAccessToRoute(user, features, r.view)
        )
        .map(
          (
            { view, label, path, icon, collapsedNavIcon, subRoutes, favorite },
            index
          ) => (
            <MenuItem
              key={index}
              textContent={label || view}
              icon={collapsedNav ? (collapsedNavIcon ?? icon) : icon}
              isActive={mainRoute.startsWith(view)}
              path={path}
              onClick={toggleClose}
              subRoutes={subRoutes}
              favorite={favorite}
              collapsedNav={collapsedNav}
            />
          )
        ),
    [features, user, mainRoute, toggleClose, collapsedNav]
  );

  return (
    <div
      className={clsx(styles.menu, {
        [styles.menuLegacy]: !collapsedNav,
      })}
    >
      {allowedRoutes}
    </div>
  );
};
